import * as React from 'react';

import {Icon, Popup} from "semantic-ui-react";

import {virtualizedTableId} from "../../VirtualizedTableUtils";

interface PortalDropdownProps {
    options: Set<string>;
    value: Set<string> | undefined;
    onChange: (opt: Set<string>) => void;
    t: reactI18Next.TranslationFunction;
}

interface IPortalDropdownState {
    open: boolean;
    scrollLeft?: number;
}

class PortalDropdownFilter extends React.Component<PortalDropdownProps, IPortalDropdownState> {
    constructor(props: PortalDropdownProps) {
        super(props);
        this.state = {
            open: false
        };
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleHorizontalScroll, true);
    }

    private handleHorizontalScroll = (e: any) => {
        if (this.state.open && this.state.scrollLeft !== undefined) {
            const optionTableElem = document.getElementById(virtualizedTableId);
            if (optionTableElem && optionTableElem !== null) {
                if (optionTableElem.scrollLeft !== this.state.scrollLeft)
                    this.setState({
                        open: false,
                        scrollLeft: undefined
                    });
            }
        }
    }

    private onChange = (value: string) => {
        const {value: filterValue} = this.props;

        if(filterValue === undefined) {
            this.props.onChange((new Set<string>()).add(value));
        } else {
            if(filterValue.has(value)) {
                filterValue.delete(value);
            } else {
                filterValue.add(value);
            }
            this.props.onChange(filterValue);
        }
    }

    private clearFilter = (event: any) => {
        event.stopPropagation();
        this.props.onChange(new Set<string>());
    }

    private onTriggerClick = () => {
        const optionTableElem = document.getElementById(virtualizedTableId);
        this.setState({
            open: true,
            scrollLeft: optionTableElem && optionTableElem !== null ? optionTableElem.scrollLeft : undefined
        });
    }

    render() {
        const hasOptionsSelected = this.props.value && this.props.value.size > 0;
        return (
            <Popup
                content={(
                    <div>
                        {
                            Array.from(this.props.options).map( (opt, index) => {
                                const isChecked = this.props.value && this.props.value.has(opt);
                                return (
                                    <div
                                        className={`portal-dropdown-option ${isChecked ? 'portal-dropdown-active-option' : ''}`}
                                        key={'protal-dropdown-key-' + index}
                                        onClick={() => this.onChange(opt)}
                                    >
                                        {isChecked && <Icon name='check'/>}
                                        {opt}
                                    </div>
                                );
                            })
                        }
                    </div>
                )}
                trigger={
                    <div
                        className={`portal-dropdown-input ${this.state.open ? 'portal-dropdown-input-active ' : ''}`}
                        onClick={this.onTriggerClick}
                    >
                        {hasOptionsSelected && <Icon name='close' onClick={(event: any) => this.clearFilter(event)}/>}
                        <Icon name='dropdown'/>
                        <span className='portal-dropdown-input-value'>
                            {
                                hasOptionsSelected
                                    // @ts-ignore condition checked already
                                    ? this.props.value.size === 1
                                        // @ts-ignore condition checked already
                                        ? this.props.value.values().next().value
                                        // @ts-ignore condition checked already
                                        : this.props.value.size + ' ' +  this.props.t('GLOBAL:ACTIVE_CHOICES')
                                    : ''
                            }
                        </span>
                    </div>
                }
                on='click'
                open={this.state.open}
                onClose={() => this.setState({open: false})}
                position='bottom center'
                basic={true}
                className='portal-dropdown-portal-container'
            />
        );
    }
}

export default PortalDropdownFilter;



// WEBPACK FOOTER //
// ./src/components/Table/components/dropdowns/PortalDropdownFilter.tsx